export default function IndicesRevisionConfiguration($translatePartialLoaderProvider) {
    // On configure la gestion de la traduction en lui indiquant quel fichier json il doit charger pour ce module
    $translatePartialLoaderProvider.addPart('indices.revision');
}

IndicesRevisionConfiguration.$inject = ['$translatePartialLoaderProvider'];
